import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function ChevronLeft(props) {
  return (
    <SvgIcon {...props}>
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />
    </SvgIcon>
  );
}

export default React.memo(ChevronLeft);



// WEBPACK FOOTER //
// ./src/icons/internals/ChevronLeft.jsx